export enum ApiActionType {
    JsonApiRequest = "jsonApiRequest",
    HtmlRequest = "htmlRequest",
}
